import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function RenameColumnDialog({ column, base, onClose, onRenamed }) {
  const [name, setName] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => { setName(column || ""); }, [column]);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.patch(`${base}/columns`, { old: column, new: name });
      toast.success(`Renamed "${column}" to "${name.trim()}"`);
      onRenamed();
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={!!column} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md bg-card" data-testid="rename-column-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">Rename field</DialogTitle></DialogHeader>
        <form onSubmit={save} className="space-y-4">
          <Input autoFocus value={name} onChange={(e) => setName(e.target.value)} data-testid="rename-column-input" />
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose} data-testid="rename-cancel-button">Cancel</Button>
            <Button type="submit" disabled={saving || !name.trim()} className="hover:bg-blue-600 hover:text-white" data-testid="rename-save-button">
              {saving && <Loader2 size={14} className="animate-spin" />} Rename
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
